// extracted by mini-css-extract-plugin
module.exports = {"linkColor":"style_linkColor__mf_G1","linksList":"style_linksList__F8vQC","bulletedListItem":"style_bulletedListItem__CRFja"};